<div class="spacing">
  <h4>CHANGE PASSWORD / SECURITY Q&A</h4>
  <div>Your password has expired. Please choose a new password.</div>
  <hr />
  <div>
    To change your password, please enter the information below. Remember, your password needs to be between at least 8 characters long and
    contain at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character (excluding <, >, and +)
    You will also need to choose a security question and answer. When you have supplied all of the information, click Submit.
  </div>
  <br/>
  <form [formGroup]="resetForm" (submit)="submit(resetForm)">

    <!-- Current password -->
    <div>
      <ptl-password-reveal-input label="Current Password" [formControlRef]="resetForm.controls.currentPassword"></ptl-password-reveal-input>
    </div>

    <!-- New PASSWORD -->
    <div>
      <ptl-password-reveal-input label="New Password" [formControlRef]="resetForm.controls.newPassword" [minLength]="8" [maxLength]="64"></ptl-password-reveal-input>
    </div>

    <!-- Reenter NEw PASSWORD -->
    <div>
      <ptl-password-reveal-input label="Reenter New Password" [formControlRef]="resetForm.controls.reenterNewPassword" [minLength]="8" [maxLength]="64"></ptl-password-reveal-input>
    </div>

    <!-- Security Question-->
    @if (showSecurityQues) {
      <div>
        Please choose a new Security Question and Answer.
      </div>
    }
    <br/>

    @if (showSecurityQues) {
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Security Question</mat-label>
          <mat-select aria-label="Security Question" [id]="" formControlName="securityQue">
            @for (opt of securityQues; track opt) {
              <mat-option [value]="opt.key">
                {{opt.key}}
              </mat-option>
            }
          </mat-select>
          @if (resetForm.controls['securityQue'].errors?.required) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
      </div>
    }

    <!-- Security Answer-->
    @if (showSecurityQues) {
      <div>
        <mat-form-field appearance="outline" floatLabel="always" class="mat-input-securityAnswer">
          <mat-label>Security Answer</mat-label>
          <input matInput type="password" type="textbox" formControlName="securityAnswer" placeholder="Security Answer" [type]="isSecurityAnswerVisible ? 'text' : 'password'">
          <span matSuffix class="material-symbols-outlined" [title]="isSecurityAnswerVisible ? 'Hide' : 'Show'" (click)="isSecurityAnswerVisible = !isSecurityAnswerVisible">
            {{isSecurityAnswerVisible ? 'visibility_off' : 'visibility' }}
          </span>
          @if (resetForm.get('securityAnswer').errors?.required) {
            <mat-error>This field is required</mat-error>
          }
          @if (resetForm.get('securityAnswer').errors?.minlength) {
            <mat-error>
              Must be at least {{ resetForm.get('securityAnswer').errors?.minlength?.requiredLength }} characters long.
            </mat-error>
          }
          @if (resetForm.get('securityAnswer').errors?.securityAnswerContainDomainOrUserName) {
            <mat-error>
              Should not contain domain, username, current password and email.
            </mat-error>
          }
          @if (resetForm.get('securityAnswer').errors?.consecutiveCharacters && resetForm.get('securityAnswer').touched) {
            <mat-error>
              Should not contain consecutive numbers or letters.
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    <div class="button-and-errors">
      <div class="errors">
        <!-- ERRORS -->
        <!-- <mat-error *ngIf="resetForm.get('password').hasError('failedLogin')">
        Custom Error
      </mat-error> -->
    </div>
    <div class="button-centerer">
      <!-- SUBMIT -->
      @if (!isLoading) {
        <button type="submit" mat-raised-button color="primary"  class="primary-btn" [disabled]="!resetForm?.valid">Submit</button>
      }
      @if (isLoading) {
        <mat-spinner [diameter]="25"></mat-spinner>
      }
    </div>
  </div>

</form>

</div>
